import { render, staticRenderFns } from "./FlexibleRulesComponent.vue?vue&type=template&id=3aaf5dad&scoped=true"
import script from "./FlexibleRulesComponent.vue?vue&type=script&lang=js"
export * from "./FlexibleRulesComponent.vue?vue&type=script&lang=js"
import style0 from "./FlexibleRulesComponent.vue?vue&type=style&index=0&id=3aaf5dad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf5dad",
  null
  
)

export default component.exports